import Actions         from "../../../model/constant/actions"
import ReducerUtils    from "../../../utils/ReducerUtils"
import ObjectUtils     from "../../../utils/ObjectUtils"
import BingGeoBidStats from "../../../model/Store/Statistics/BingGeoBidStats"

const retrieveGeoBidStatsForAccount = (state,action) =>{
  if (action.stats){
    if (state[action.accountId]){
      var newState={}
      for (let stat of state[action.accountId] ){ newState[stat.CampaignBingId+stat.Day+stat.SpecificLocationId] = stat }
      for (let stat of action.stats            ){ newState[stat.CampaignBingId+stat.Day+stat.SpecificLocationId] = stat }
      return {...state, [action.accountId] : ObjectUtils.getObjectValues(newState)}
    }
    return {...state,[action.accountId] : action.stats}
  }
  return {...state,[action.accountId] : []}
}
interface BingGeoBidStatsByAccount{
  [accountId:number] : BingGeoBidStats[]
}
export const GeoBidStats = ReducerUtils.createReducer<BingGeoBidStatsByAccount>({},{
  [Actions.RETRIEVE_BING_GEOBID_STATS_OF_ACCOUNT] : retrieveGeoBidStatsForAccount
})
